{
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "close": "Fermer",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "update": "Mettre à jour",
    "manage": "Gérer",
    "retry": "Réessayer",
    "loading": "Chargement...",
    "saving": "Enregistrement...",
    "applying": "Application...",
    "selectAll": "Tout sélectionner",
    "unselectAll": "Tout désélectionner",
    "clearAll": "Tout effacer",
    "clear": "Effacer",
    "invert": "Inverser",
    "search": "Rechercher",
    "selected": "{count, plural, =1 {sélectionné} other {sélectionnés}}",
    "of": "sur",
    "noData": "Aucune donnée disponible",
    "back": "Retour",
    "apply": "Appliquer",
    "remove": "Supprimer",
    "create": "Créer",
    "default": "Par défaut",
    "none": "Aucun",
    "continue": "Continuer",
    "status": "Statut",
    "select": "Sélectionner",
    "done": "Terminé",
    "next": "Suivant",
    "searchCombobox": {
      "search": "Rechercher...",
      "searchResults": "Résultats de recherche",
      "noResults": "Aucun résultat trouvé",
      "errorOccurred": "Une erreur est survenue",
      "minChars": "Saisissez au moins {{ count }} caractères",
      "resultCount": "{{ current }} / {{ total }} résultats"
    },
    "openInNewTab": "Nouvel onglet"
  },
  "shared": {
    "input": {
      "optional": "(facultatif)",
      "clear": "Effacer",
      "reveal": "Afficher la valeur saisie",
      "hide": "Masquer la valeur saisie"
    },
    "colorPicker": {
      "custom": "Couleur personnalisée",
      "colors": {
        "blue": "Bleu",
        "sky": "Ciel",
        "teal": "Turquoise",
        "emerald": "Émeraude",
        "amber": "Ambre",
        "orange": "Orange",
        "rose": "Rose",
        "fuchsia": "Fuchsia",
        "violet": "Violet",
        "slate": "Ardoise"
      }
    },
    "spotlight": {
      "search": "Rechercher",
      "esc": "ÉCHAP",
      "navigate": "Naviguer",
      "select": "Sélectionner",
      "resultCount": "{count, plural, =0 {Aucun résultat} one {1 résultat} other {# résultats}}",
      "blocked": "Fermez le panneau ouvert avant d'en ouvrir un autre."
    },
    "unsavedChanges": {
      "title": "Modifications non enregistrées",
      "message": "Vous avez des modifications non enregistrées. Que souhaitez-vous faire ?",
      "cancel": "Annuler",
      "leave": "Quitter sans enregistrer",
      "save": "Enregistrer et quitter",
      "switch": {
        "leave": "Abandonner les modifications",
        "save": "Enregistrer et changer"
      }
    },
    "pagination": {
      "previous": "Précédent",
      "next": "Suivant",
      "pageOf": "Page {{ current }} sur {{ total }}",
      "results": "{count, plural, =1 {1 résultat} other {# résultats}}",
      "rangeSummary": "{{ from }}–{{ to }} sur {{ total }}",
      "goToPage": "Aller à la page {{ page }}"
    },
    "discardChangesDialog": {
      "title": "Abandonner les modifications ?",
      "message": "Vous avez des modifications non enregistrées. Si vous quittez maintenant, vos modifications seront perdues.",
      "keepEditing": "Continuer l’édition",
      "discardChanges": "Abandonner les modifications"
    },
    "confirmActionDialog": {
      "title": "Confirmer l’action",
      "message": "Êtes-vous sûr de vouloir continuer ?",
      "confirmLabel": "Confirmer",
      "cancelLabel": "Annuler"
    },
    "idleWarning": {
      "title": "Toujours là ?",
      "message": "Vous allez bientôt être déconnecté pour inactivité. Choisissez si vous souhaitez rester connecté.",
      "stay": "Rester connecté",
      "logout": "Se déconnecter"
    },
    "planShortcutsHelp": {
      "title": "Raccourcis clavier et souris",
      "close": "Fermer",
      "categoryNavigation": "Navigation",
      "categoryZoom": "Zoom",
      "actionPan": "Déplacer la vue",
      "actionWheelZoom": "Zoomer / dézoomer",
      "actionDoubleClickZoom": "Zoomer à la position du curseur",
      "actionShiftDoubleClickZoom": "Dézoomer à la position du curseur",
      "actionRectangleZoom": "Zoomer sur la zone sélectionnée",
      "actionFitToView": "Ajuster le plan à la vue",
      "actionBackToTopview": "Retour à la vue d'ensemble",
      "actionZoomIn": "Zoomer",
      "actionZoomOut": "Dézoomer",
      "actionToggleHelp": "Afficher / masquer cette aide",
      "keyMouseLeftDrag": "Clic gauche + glisser",
      "keyMouseWheel": "Molette",
      "keyDoubleClick": "Double-clic",
      "keyShiftDoubleClick": "Maj + Double-clic",
      "keyAltDrag": "Alt + glisser",
      "keyEscape": "Échap",
      "keyF": "F",
      "keyPlus": "+",
      "keyMinus": "-",
      "keyQuestion": "?",
      "categorySelection": "Sélection",
      "actionPanArrows": "Déplacer la vue",
      "actionOpenSearch": "Rechercher une place",
      "actionOverviewPeek": "Aperçu d'ensemble (maintenir)",
      "actionMarqueeSelect": "Sélection rectangulaire",
      "actionLassoSelect": "Sélection au lasso",
      "actionPlainClickSelect": "Sélectionner la place",
      "actionPlainClickPreview": "Ouvrir la fiche de la place",
      "actionSelectAll": "Tout sélectionner",
      "actionDismiss": "Fermer / annuler",
      "keyClick": "Clic",
      "keyDrag": "glisser",
      "keyCtrl": "Ctrl",
      "keyShift": "Maj",
      "keyAlt": "Alt",
      "keyHome": "Origine",
      "keyBackspace": "Retour arrière",
      "keyArrows": "Flèches",
      "keyA": "A",
      "keyZ": "Z"
    },
    "drawer": {
      "close": "Fermer le panneau",
      "closeEsc": "Fermer (Échap)"
    },
    "toast": {
      "dismiss": "Fermer",
      "region": "Notifications",
      "count": "{count, plural, one {# occurrence} other {# occurrences}}",
      "clearAll": "Tout effacer ({count})"
    },
    "filterBar": {
      "filterOptions": "Options de filtre",
      "showing": "Affichage de {{ totalCount }} {{ itemLabel }}",
      "clearAll": "Tout effacer",
      "moreFilters": "Plus de filtres",
      "moreFiltersPanel": "Plus de filtres",
      "tiersCustomised": "(personnalisé)",
      "resetTiers": "Réinitialiser les filtres",
      "resetTiersHint": "Restaurer les filtres par défaut. Les valeurs saisies ne sont pas modifiées.",
      "facetActive": "Actif"
    },
    "listEmpty": {
      "adjustFilters": "Essayez d’ajuster vos filtres pour trouver ce que vous cherchez.",
      "clearAllActive": "Effacer tous les filtres actifs",
      "clearAllFilters": "Effacer tous les filtres"
    },
    "listError": {
      "retryLoading": "Réessayer le chargement du contenu",
      "retrying": "Nouvelle tentative...",
      "tryAgain": "Réessayer",
      "sessionExpired": "Session expirée",
      "accessDenied": "Accès refusé",
      "maintenance": "Maintenance",
      "somethingWentWrong": "Une erreur est survenue",
      "messages": {
        "network": "Impossible de se connecter. Veuillez vérifier votre connexion internet.",
        "authorization": "Votre session a expiré. Veuillez vous reconnecter.",
        "forbidden": "Vous n’avez pas la permission d’accéder à cette ressource.",
        "notFound": "La ressource demandée est introuvable.",
        "conflict": "Cette ressource a été modifiée par un autre utilisateur. Veuillez actualiser.",
        "validation": "La requête contient des données invalides.",
        "rateLimit": "Trop de requêtes. Veuillez patienter un instant et réessayer.",
        "timeout": "La requête a expiré. Veuillez réessayer.",
        "server": "Une erreur serveur est survenue. Veuillez réessayer plus tard.",
        "maintenance": "Le système est en maintenance. Veuillez réessayer plus tard.",
        "unknown": "Une erreur inattendue est survenue. Veuillez réessayer."
      }
    },
    "listState": {
      "loadingContent": "Chargement du contenu",
      "retrying": "Nouvelle tentative",
      "retryingEllipsis": "Nouvelle tentative..."
    },
    "errorSection": {
      "retrying": "Nouvelle tentative...",
      "retry": "Réessayer"
    },
    "filterSummary": {
      "noFilters": "Aucun filtre appliqué",
      "fieldSearch": "Recherche",
      "fieldGroups": "Groupes",
      "fieldStatus": "Statut",
      "fieldType": "Type",
      "fieldVenue": "Lieu",
      "fieldDate": "Date",
      "presetUpcoming": "À venir",
      "presetToday": "Aujourd’hui",
      "presetThisWeek": "Cette semaine",
      "presetThisMonth": "Ce mois-ci",
      "presetNext30Days": "30 prochains jours",
      "presetAllDates": "Toutes les dates",
      "presetCustomRange": "Plage personnalisée"
    },
    "filterDropdown": {
      "noOptions": "Aucune option disponible",
      "noResults": "Aucun résultat",
      "search": "Rechercher…",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "expand": "Développer",
      "collapse": "Réduire"
    },
    "select": {
      "clearSelection": "Effacer la sélection",
      "selectedCount": "{{ count }} sélectionnés",
      "allSelected": "tous sélectionnés ({{ count }}/{{ total }})"
    },
    "asyncSelect": {
      "loading": "Chargement…",
      "loadingMore": "Chargement…",
      "empty": "Aucun résultat",
      "noResults": "Aucune correspondance pour votre recherche.",
      "typeToSearch": "Saisissez pour rechercher",
      "typeAtLeast": "Saisissez au moins {{ count }} caractères",
      "error": "Une erreur est survenue lors du chargement des résultats.",
      "clearAll": "Tout effacer",
      "clearSelection": "Effacer la sélection",
      "selectedCount": "{{ count }} sélectionnés",
      "remove": "Retirer {{ label }}",
      "loadMore": "Voir plus",
      "countOf": "{{ count }} sur {{ total }}"
    },
    "optionalSegmentedControl": {
      "all": "Tous"
    },
    "actionMenu": {
      "noActions": "Aucune action disponible"
    },
    "dateRangePicker": {
      "trigger": "Dates",
      "dialogLabel": "Sélection de dates",
      "shortcuts": "Raccourcis",
      "prevMonth": "Mois précédent",
      "nextMonth": "Mois suivant",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "inputPlaceholder": "jj/mm/aaaa",
      "clear": "Effacer",
      "apply": "Appliquer",
      "preset": {
        "upcoming": "À venir",
        "today": "Aujourd'hui",
        "thisWeek": "Cette semaine",
        "thisWeekend": "Ce week-end",
        "next7Days": "7 prochains jours",
        "thisMonth": "Ce mois-ci",
        "next30Days": "30 prochains jours",
        "last7Days": "7 derniers jours",
        "last30Days": "30 derniers jours",
        "all": "Toutes les dates",
        "custom": "Plage personnalisée"
      },
      "mode": {
        "range": "Plage",
        "from": "À partir de",
        "until": "Jusqu'à",
        "single": "Jour précis"
      },
      "field": {
        "from": "Du",
        "to": "Au",
        "single": "Le"
      },
      "clearStart": "Effacer la date de début",
      "clearEnd": "Effacer la date de fin",
      "openMonthYear": "Choisir le mois et l'année",
      "prevYear": "Année précédente",
      "nextYear": "Année suivante",
      "rangeLength": "{count, plural, =1 {1 jour} other {# jours}}",
      "invalidDate": "Saisissez une date valide (jj/mm/aaaa)",
      "dateOutOfRange": "Cette date est en dehors de la plage autorisée",
      "invalidTime": "Saisissez une heure valide (hh:mm)",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "timePlaceholder": "hh:mm",
      "confirmTime": "OK",
      "backToCalendar": "Retour au calendrier",
      "setTime": "Définir l'heure",
      "hoursLabel": "Heures",
      "minutesLabel": "Minutes",
      "summary": {
        "all": "Toutes les dates",
        "from": "À partir du {{ date }}",
        "until": "Jusqu'au {{ date }}",
        "range": "{{ from }} → {{ to }}",
        "partial": "{{ from }} → …",
        "prompt": "Sélectionnez une plage",
        "at": "à"
      },
      "clearSelection": "Effacer les dates"
    },
    "selectionBar": {
      "clearAll": "Tout effacer",
      "regionLabel": "Actions sur la sélection"
    },
    "customerType": {
      "physical": "Particulier",
      "moral": "Entreprise"
    },
    "seatDetail": {
      "customer": "Client",
      "anonymousCustomer": "Client anonyme",
      "unidentifiedCustomer": "Client inconnu",
      "customerType": "Type",
      "orderId": "Commande",
      "bookingDate": "Réservé le",
      "payment": "Paiement",
      "channel": "Canal",
      "detailsUnavailable": "Détails indisponibles"
    }
  },
  "navigation": {
    "clients": "Clients",
    "redditions": "Redditions",
    "evenements": "Evènements",
    "formules": "Formules",
    "fichierSap": "Fichier SAP",
    "rapprochements": "Rapprochements",
    "rapprochementManuel": "Rapprochement manuel",
    "parametrage": "Paramétrage",
    "commissions": "Commissions",
    "dashboard": "Tableau de bord",
    "quickSale": "Vente rapide",
    "customers": "Clients",
    "subscriptions": "Formules",
    "catalog": "Catalogue",
    "events": "Évènements",
    "operations": "Opérations",
    "orders": "Commandes",
    "salesLaunch": "Mise en vente",
    "products": "Produits",
    "resale": "Revente",
    "reports": "Rapports",
    "settings": "Paramètres",
    "mockup": "Maquette billet",
    "channels": "Canaux",
    "resaleConfiguration": "Configuration revente",
    "logo": "Logo BackStage",
    "appName": "BackStage",
    "noItems": "Aucun élément",
    "components": "Composants",
    "featureFlagAdmin": "Feature flags"
  },
  "bulkActions": {
    "close": "Fermer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "confirmPrompt": "Cette action est irréversible. Continuer ?",
    "confirmPromptDanger": "Cette action est irréversible. Continuer ?",
    "modify": "Modifier les filtres",
    "doneEditing": "Terminé",
    "retry": "Réessayer",
    "executing": "Traitement…",
    "counting": "Comptage…",
    "count": "{count, plural, one {# élément} other {# éléments}}",
    "countFailed": "Impossible de charger le nombre.",
    "downloaded": "Téléchargé : {filename}",
    "partialTitle": "Partiellement effectué",
    "partial": "{succeeded} réussi(s), {failed} en échec."
  },
  "clipboard": {
    "copy": "Copier",
    "copied": "Copié !",
    "copyFailed": "Échec de la copie",
    "copyDenied": "Accès au presse-papiers refusé",
    "copyUnsupported": "Copie non prise en charge par ce navigateur"
  },
  "confirmDialog": {
    "applyResult": "Résultat de l’application",
    "confirmChanges": "Confirmer les modifications",
    "closeDialog": "Fermer la boîte de dialogue",
    "actionSummary": "Résumé des actions",
    "seatCount": "{count, plural, =1 {1 place} other {# places}}",
    "alsoAppliedTo": "Également appliqué à",
    "applyChangesTo": "Appliquer les modifications suivantes à",
    "seats": "{count, plural, =1 {place} other {places}}?",
    "category": "Catégorie :",
    "contingent": "Contingent :",
    "unavailability": "Indisponibilité :",
    "action": "Action :",
    "clearCategory": "Effacer la catégorie",
    "clearContingent": "Effacer le contingent",
    "freeUpSeats": "Libérer les places (supprimer l’indisponibilité)",
    "noChangesSelected": "Aucune modification sélectionnée.",
    "alsoApplyToOtherSessions": "Appliquer également aux autres sessions d’évènement",
    "loadingEvents": "Chargement des évènements...",
    "noOtherEvents": "Aucun autre évènement ne partage ce plan.",
    "applyChanges": "Appliquer les modifications",
    "changesFailed": "Les modifications ont échoué",
    "partiallyApplied": "Partiellement appliqué",
    "changesAppliedSuccessfully": "Modifications appliquées avec succès",
    "categoryChanged": "Catégorie modifiée",
    "contingentChanged": "Contingent modifié",
    "unavailabilityChanged": "Indisponibilité modifiée",
    "seatsFreedUp": "Places libérées",
    "partialReasons": {
      "default": "Certaines modifications n’ont pas pu être appliquées.",
      "somePartiallyApplicable": "Certaines modifications ne sont que partiellement applicables.",
      "freeAndUnavailableModified": "Seules les places libres et indisponibles ont été modifiées.",
      "freeModified": "Seules les places libres ont été modifiées.",
      "freeAndSoldModified": "Seules les places libres et vendues ont été modifiées.",
      "unavailableModified": "Seules les places indisponibles ont été modifiées.",
      "soldModified": "Seules les places vendues ont été modifiées."
    }
  },
  "customers": {
    "bulkActions": {
      "archive": {
        "title": "{count, plural, one {Archiver le client} other {Archiver les clients}}",
        "menuLabel": "Archiver les clients",
        "resultTitle": "Clients archivés",
        "caveat": "Les clients archivés pourront être restaurés plus tard.",
        "failed": "L'archivage des clients a échoué. Veuillez réessayer."
      },
      "anonymize": {
        "title": "{count, plural, one {Anonymiser le client} other {Anonymiser les clients}}",
        "menuLabel": "Anonymiser les clients",
        "resultTitle": "Clients anonymisés",
        "caveat": "Les données personnelles seront définitivement perdues.",
        "failed": "L'anonymisation des clients a échoué. Veuillez réessayer."
      },
      "export": {
        "title": "{count, plural, one {Exporter le client} other {Exporter les clients}}",
        "resultTitle": "Export prêt"
      },
      "block": {
        "emptySelection": "Sélectionnez au moins un client.",
        "emptyFilter": "Aucun client ne correspond au filtre actuel.",
        "exceedsLimit": "Trop de clients — au maximum {max} à la fois."
      },
      "andMore": "{count, plural, one {et 1 autre} other {et # autres}}",
      "scope": {
        "allCustomers": "Tous les clients",
        "label": {
          "type": "Type :",
          "groups": "Groupes :",
          "tags": "Étiquettes :",
          "webLogin": "Login WEB :",
          "customerNumber": "N° client :",
          "createdBy": "Créé par :",
          "creationDate": "Créé :",
          "search": "Recherche :"
        },
        "value": {
          "raw": "{value}",
          "type": "{type, select, onlyPhysical {Particuliers} onlyMoral {Organisations} other {Tous}}"
        }
      }
    },
    "required": "Ce champ est requis.",
    "invalidEmail": "Veuillez entrer une adresse email valide.",
    "birthDateMin": "La date de naissance ne peut pas être antérieure à {{ min }}.",
    "birthDateMax": "La date de naissance doit être d’au moins 12 ans (avant {{ max }}).",
    "birthDateFormat": "Saisissez une date valide (jj/mm/aaaa).",
    "birthDateOutOfRange": "La date de naissance est en dehors de la plage autorisée.",
    "birthDatePlaceholder": "jj/mm/aaaa",
    "openCalendar": "Ouvrir le calendrier",
    "clearBirthDate": "Effacer la date de naissance",
    "minLength": "Minimum {{ requiredLength }} caractères requis.",
    "maxLength": "Maximum {{ requiredLength }} caractères autorisés.",
    "zipCodeNumeric": "Le code postal ne doit contenir que des chiffres.",
    "emailExists": "Cette adresse email est déjà utilisée.",
    "emailsLengthError": "Vous pouvez ajouter au maximum {{ max }} adresses email (actuellement {{ actual }}).",
    "defaultEmailRequired": "Veuillez marquer une adresse email comme adresse par défaut.",
    "defaultEmailEmpty": "L’adresse email par défaut ne doit pas être vide.",
    "emailNotUnique": "Les adresses email en double ne sont pas autorisées.",
    "phoneLengthError": "Vous pouvez ajouter au maximum {{ max }} numéros de téléphone (actuellement {{ actual }}).",
    "defaultPhoneRequired": "Veuillez marquer un numéro de téléphone comme numéro par défaut.",
    "defaultPhoneEmpty": "Le numéro de téléphone par défaut ne doit pas être vide.",
    "phoneNotUnique": "Les numéros de téléphone en double ne sont pas autorisés.",
    "addressLengthError": "Vous pouvez ajouter au maximum {{ max }} adresses (actuellement {{ actual }}).",
    "defaultAddressRequired": "Veuillez marquer une adresse comme adresse par défaut.",
    "addressNotUnique": "Les adresses en double ne sont pas autorisées.",
    "addressType": {
      "label": "Type d’adresse",
      "home": "Domicile",
      "billing": "Facturation",
      "shipping": "Livraison"
    },
    "selectionBar": {
      "bulkActions": "Actions groupées",
      "selectedCount": "{count, plural, one {# client sélectionné} other {# clients sélectionnés}}",
      "selectedLimit": "{{ count }} / 500 clients sélectionnés (limite)",
      "selectAll": "Tout sélectionner",
      "selectAllOnPage": "Tout sélectionner sur la page",
      "selectRow": "Sélectionner le client",
      "clearAll": "Tout effacer",
      "regionLabel": "Actions sur la sélection",
      "selectedAllMatching": "{count, plural, one {# client correspondant sélectionné} other {Les # clients correspondants sont sélectionnés}}",
      "escalate": "Sélectionner les {{ count }} clients correspondants"
    },
    "operations": {
      "archiveSuccess": "Archivage effectué avec succès",
      "archiveFailed": "Échec de l'archivage.",
      "anonymizeSuccess": "Anonymisation effectuée avec succès",
      "anonymizeFailed": "Échec de l'anonymisation.",
      "bulkEditFailed": "Échec de la modification groupée.",
      "unexpectedError": "Une erreur est survenue. Veuillez réessayer."
    },
    "page": {
      "title": "Clients",
      "subtitle": "Rechercher et gérer les comptes clients",
      "archive": "Archiver",
      "anonymize": "Anonymiser",
      "bulkEdit": "Modification groupée",
      "irreversibleAnonymize": "Cette action est irréversible. Les données anonymisées ne pourront pas être récupérées.",
      "archiveWarning": "Ce client sera archivé et retiré de la liste active.",
      "exportCsv": "Exporter en CSV",
      "export": "Exporter",
      "bulkActions": "Actions en masse",
      "createNew": "Créer un nouveau client",
      "exportSuccess": "Export terminé",
      "exportFailed": "Échec de l’export — veuillez réessayer",
      "totalLabel": "clients",
      "welcomeBody": "Aucun client pour le moment.",
      "emptyBody": "Aucun client ne correspond à vos filtres."
    },
    "filtersPage": {
      "searchPlaceholder": "Nom, email, téléphone...",
      "itemLabel": "clients",
      "typeFilter": "Type de client",
      "searchLabel": "Recherche",
      "groupFilter": "Groupe",
      "tagFilter": "Étiquette",
      "webLoginLabel": "Login WEB",
      "webLoginPlaceholder": "Ex. 400",
      "customerNumberLabel": "N° client",
      "customerNumberPlaceholder": "Ex. 115",
      "createdByFilter": "Créé par",
      "creationDateLabel": "Date de création",
      "viewToggle": "Mode d’affichage",
      "viewList": "Vue liste",
      "viewTable": "Vue tableau",
      "viewGrid": "Vue grille"
    },
    "groupRail": {
      "groupsTitle": "Groupes",
      "searchGroups": "Rechercher des groupes…",
      "clearSearch": "Effacer la recherche",
      "allCustomers": "Tous les clients",
      "groupsError": "Impossible de charger les groupes",
      "retry": "Réessayer",
      "groupAriaLabel": "Groupes"
    },
    "card": {
      "customerLabel": "Client : {{ name }}",
      "anonymous": "Anonyme",
      "anonymized": "Anonymisé",
      "anonymizedCustomerName": "Client anonymisé",
      "activeSubscription": "Formule actif",
      "actionsFor": "Actions pour {{ name }}",
      "login": "(connexion)",
      "viewOrders": "Voir les commandes",
      "archive": "Archiver",
      "anonymize": "Anonymiser"
    },
    "table": {
      "columns": {
        "type": "Type",
        "name": "Nom",
        "id": "ID",
        "email": "E-mail",
        "phone": "Téléphone",
        "address": "Adresse",
        "color": "Couleur",
        "actions": "Actions",
        "select": "Tout sélectionner"
      },
      "columnPicker": {
        "trigger": "Colonnes",
        "panelAria": "Choisir les colonnes affichées",
        "reset": "Réinitialiser les colonnes",
        "resetHint": "Restaurer les colonnes par défaut",
        "customised": "(personnalisé)"
      }
    },
    "detail": {
      "noCustomerSelected": "Aucun client sélectionné",
      "noCustomerSelectedHint": "Sélectionnez un client dans la liste pour afficher sa fiche.",
      "informations": "Informations",
      "ordersTab": "Commandes",
      "by": "par {{ name }}",
      "loadFailed": "Échec du chargement des détails du client. Veuillez réessayer.",
      "noCustomerId": "Aucun identifiant client fourni"
    },
    "editForm": {
      "identity": "Identité",
      "firstName": "Prénom",
      "lastName": "Nom",
      "birthDate": "Date de naissance",
      "corporateName": "Raison sociale",
      "civility": "Civilité",
      "civilityPlaceholder": "Sélectionner une civilité",
      "nationality": "Nationalité",
      "nationalityPlaceholder": "Sélectionner une nationalité",
      "language": "Langue",
      "languagePlaceholder": "Sélectionner une langue",
      "responsibility": "Titre",
      "responsibilityPlaceholder": "Sélectionner un titre",
      "group": "Groupe",
      "groupPlaceholder": "Sélectionner un groupe",
      "referentialsLoadFailed": "Impossible de charger les listes de choix. Réessayez avant d'enregistrer.",
      "emails": "Emails",
      "addEmail": "Ajouter un email",
      "emailPlaceholder": "email@exemple.com",
      "setAsDefault": "Définir par défaut",
      "removeEmail": "Supprimer l’email",
      "phones": "Téléphones",
      "addPhone": "Ajouter un téléphone",
      "phonePlaceholder": "+33...",
      "removePhone": "Supprimer le téléphone",
      "birthDatePlaceholder": "jj/mm/aaaa",
      "birthDateOpen": "Ouvrir le calendrier",
      "addresses": "Adresses",
      "addAddress": "Ajouter une adresse",
      "removeAddress": "Supprimer l’adresse",
      "street": "Rue",
      "additionalAddress": "Complément d’adresse",
      "zipCode": "Code postal",
      "city": "Ville",
      "country": "Pays",
      "validationFailed": "La validation a échoué. Veuillez vérifier les champs du formulaire.",
      "saveFailed": "Échec de l’enregistrement du client. Veuillez réessayer."
    },
    "createDialog": {
      "title": "Créer un nouveau client",
      "subtitle": "Ajoutez un particulier ou une organisation à votre base clients.",
      "referentialsLoadFailed": "Impossible de charger les options du formulaire. Certaines listes peuvent être vides.",
      "retry": "Réessayer",
      "closeDialog": "Fermer la boîte de dialogue",
      "customerType": "Type de client",
      "individual": "Particulier",
      "organization": "Organisation",
      "group": "Groupe",
      "groupRequired": "Groupe *",
      "selectOption": "— Sélectionner —",
      "firstName": "Prénom",
      "lastName": "Nom",
      "civility": "Civilité",
      "nationality": "Nationalité",
      "language": "Langue",
      "titleField": "Titre",
      "corporateName": "Raison sociale",
      "checkingEmail": "Vérification de la disponibilité de l’email",
      "creating": "Création...",
      "createFailed": "Échec de la création du client. Veuillez réessayer.",
      "noAddressYet": "Aucune adresse"
    },
    "enums": {
      "individual": "Particulier",
      "organization": "Organisation",
      "default": "Par défaut",
      "operator": "Opérateur",
      "producer": "Producteur",
      "contact": "Contact",
      "pointOfSale": "Point de vente",
      "purchaseWithoutAccount": "Achat sans compte",
      "anonymous": "Anonyme",
      "consumer": "Consommateur",
      "anonymousByChannel": "Anonyme par canal"
    },
    "orders": {
      "filterBar": {
        "status": "Statut",
        "searchEvents": "Rechercher un évènement...",
        "noEventsFound": "Aucun évènement trouvé",
        "clearEvent": "Effacer la sélection",
        "sortBy": "Trier par",
        "order": "commande",
        "orders": "commandes"
      },
      "sort": {
        "dateNewest": "Date (récent)",
        "dateOldest": "Date (ancien)",
        "amountHighest": "Montant (décroissant)",
        "amountLowest": "Montant (croissant)"
      },
      "summary": {
        "place": "place",
        "places": "places",
        "article": "article",
        "articles": "articles"
      },
      "noResultsTitle": "Aucune commande",
      "notAvailable": "Les commandes ne sont pas disponibles dans ce contexte.",
      "notAvailableTitle": "Commandes indisponibles",
      "loadingOrders": "Chargement des commandes...",
      "loadFailed": "Échec du chargement des commandes. Veuillez réessayer.",
      "retry": "Réessayer",
      "card": {
        "order": "Commande",
        "openOrder": "Ouvrir la commande #{{ number }}",
        "date": "Date : {{ value }}",
        "total": "Total : {{ value }}",
        "nameLabel": "Nom : ",
        "categoryLabel": "Cat. : ",
        "rateLabel": "Tarif : ",
        "qtyLabel": "Qté : ",
        "unitPriceLabel": "P.U. : ",
        "amountLabel": "Mnt : ",
        "pendingStatuses": "(+{{ count }})"
      },
      "status": {
        "paid": "Payé",
        "edited": "Édité",
        "reserved": "Réservé",
        "canceled": "Annulé"
      },
      "itemType": {
        "ticket": "ticket",
        "tickets": "tickets",
        "subscription": "formule",
        "subscriptions": "formules",
        "product": "produit",
        "products": "produits"
      },
      "typeBadge": {
        "EventSession": "Session",
        "SubscriptionGroup": "Formule",
        "Product": "Produit"
      }
    }
  },
  "diagnostics": {
    "mark": {
      "label": "Repère {{ n }}",
      "toast": "Repère {{ n }} enregistré"
    },
    "export": {
      "title": "Exporter le diagnostic",
      "noteLabel": "Que s'est-il passé ?",
      "notePlaceholder": "Décrivez brièvement le problème observé…",
      "fullFidelityWarning": "Cette capture contient des données en fidélité complète (corps de requêtes). Relisez-la avant de l'envoyer.",
      "truncated": "Certains événements ont été perdus — la capture est incomplète.",
      "markHint": "Astuce : marquez le moment du problème avec",
      "copy": "Copier",
      "copied": "Copié",
      "download": "Télécharger"
    }
  },
  "drafts": {
    "button": {
      "label": "Brouillons ({{count}})"
    },
    "saveAs": {
      "title": "Enregistrer le brouillon",
      "nameLabel": "Nom du brouillon",
      "placeholder": "Nommez ce brouillon",
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "retention": {
      "notice": "Les brouillons sont conservés {days, plural, one {# jour} other {# jours}} après la dernière modification, puis supprimés automatiquement."
    },
    "expiry": {
      "chip": "{daysLeft, plural, =0 {Expire aujourd'hui} one {Expire dans # jour} other {Expire dans # jours}}"
    },
    "status": {
      "tooLarge": "Ce brouillon est trop volumineux pour être enregistré.",
      "quotaExceeded": "L'espace de stockage du navigateur est saturé : ce brouillon n'a pas pu être enregistré.",
      "storageUnavailable": "Le navigateur bloque le stockage local : ce brouillon n'a pas pu être enregistré.",
      "unexpected": "Ce brouillon n'a pas pu être enregistré en raison d'une erreur inattendue.",
      "lastSaved": "Dernière version enregistrée le {{date}}.",
      "neverSaved": "Aucune version de ce brouillon n'a été enregistrée."
    },
    "resumeMiss": {
      "expired": "Ce brouillon avait expiré et a été supprimé.",
      "corrupt": "Ce brouillon était illisible et a été supprimé.",
      "absent": "Ce brouillon n'existe plus.",
      "unavailable": "Impossible de lire les brouillons : le navigateur bloque le stockage local.",
      "undecodable": "Ce brouillon a été enregistré par une autre version de l'application et ne peut pas être repris."
    },
    "eviction": {
      "notice": "{count, plural, one {# ancien brouillon a été supprimé} other {# anciens brouillons ont été supprimés}} pour libérer de l'espace.",
      "noticeForKind": "{count, plural, one {# ancien brouillon « {kind} » a été supprimé} other {# anciens brouillons « {kind} » ont été supprimés}} pour libérer de l'espace."
    },
    "picker": {
      "title": "Brouillons — {{label}}",
      "empty": "Vous n'avez aucun brouillon enregistré.",
      "progress": "Étape {{done}} sur {{total}}",
      "details": "Détails",
      "resume": "Reprendre",
      "delete": "Supprimer",
      "deleteConfirm": "Supprimer ce brouillon ?",
      "deleteCancel": "Annuler",
      "deleteYes": "Supprimer",
      "close": "Fermer",
      "startNew": "Nouveau",
      "count": "{count, plural, one {# brouillon enregistré} other {# brouillons enregistrés}}",
      "search": "Rechercher un brouillon…",
      "searchLabel": "Rechercher un brouillon",
      "noMatchesTitle": "Aucun résultat",
      "noMatches": "Aucun brouillon ne correspond à « {{term}} »"
    }
  },
  "drawer": {
    "backTo": {
      "order": "Retour à la commande #{{ id }}",
      "customer": "Retour au client #{{ id }}",
      "subscription": "Retour à l’abonnement #{{ id }}",
      "event": "Retour à l’événement #{{ id }}",
      "salesLaunch": "Retour à la mise en vente #{{ id }}",
      "planSession": "Retour au plan de la séance #{{ id }}"
    },
    "noAccess": {
      "title": "Accès refusé",
      "message": "Vous n’avez pas les droits nécessaires pour consulter cette fiche."
    }
  },
  "errors": {
    "end-print-subscription-card": {
      "no-printable-seats": "Cette carte est déjà enregistrée comme éditée. Aucune action supplémentaire n'est nécessaire.",
      "seats-not-found": "L'enregistrement de la carte a échoué : la place est introuvable côté serveur. La carte est bien sortie de l'imprimante — contactez le support avec la référence ci-dessous.",
      "order-items-not-found": "L'enregistrement de la carte a échoué : la ligne de commande est introuvable côté serveur. La carte est bien sortie de l'imprimante — contactez le support avec la référence ci-dessous.",
      "bulk-update-failed": "L'enregistrement de la carte a échoué côté serveur. La carte est bien sortie de l'imprimante ; réessayez l'enregistrement."
    },
    "connectionLost": "Connexion perdue. Veuillez vérifier votre connexion internet.",
    "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
    "forbidden": "Vous n’avez pas la permission d’accéder à cette ressource.",
    "badRequest": "La requête n’a pas pu être traitée. Veuillez réessayer.",
    "serverError": "Erreur serveur. Veuillez réessayer.",
    "timeout": "La requête a expiré. Veuillez réessayer.",
    "notFound": "La ressource demandée est introuvable.",
    "rateLimited": "Trop de requêtes. Veuillez patienter un instant et réessayer.",
    "unknown": "Une erreur est survenue. Veuillez réessayer.",
    "webglNotSupported": "Votre navigateur ne prend pas en charge WebGL, nécessaire pour le visualiseur de plan.",
    "engineInitFailed": "Échec de l’initialisation du visualiseur de plan. Veuillez actualiser la page.",
    "seatDataLoadFailed": "Échec du chargement des données de places pour ce bloc. Veuillez réessayer.",
    "loadEventsFailed": "Échec du chargement des évènements. Cliquez pour réessayer.",
    "saveFailed": "Échec de l’enregistrement. Veuillez réessayer.",
    "saveSuccess": "Modifications enregistrées avec succès",
    "versionConflict": "Cette commande a été modifiée par un autre utilisateur. Rafraîchissement en cours...",
    "apply-seat-settings.invalid-target-ids": "Vous n'avez pas les droits sur la cible choisie. Sélectionnez une autre catégorie, un autre contingent ou une autre indisponibilité.",
    "apply-seat-settings.validation-error": "Aucune place ne peut recevoir cette modification. Ajustez la sélection ou la cible.",
    "apply-seat-settings.at-least-one-target-required": "Choisissez une valeur à appliquer.",
    "apply-seat-settings.seats-not-updated": "Les places ont changé entre l'aperçu et l'enregistrement. Actualisez l'aperçu.",
    "reference": "Référence :",
    "copyReference": "Copier la référence",
    "copied": "Copié",
    "rendering": {
      "interrupted": "Affichage du plan interrompu. Restauration en cours…",
      "recovered": "Affichage du plan rétabli.",
      "unavailable": "L’affichage du plan est indisponible. Actualisez la page pour le relancer."
    },
    "transport": {
      "NETWORK_ERROR": "Connexion perdue. Veuillez vérifier votre connexion internet.",
      "TIMEOUT": "La requête a expiré. Veuillez réessayer.",
      "BAD_REQUEST": "La requête n’a pas pu être traitée. Veuillez réessayer.",
      "UNAUTHORIZED": "Votre session a expiré. Veuillez vous reconnecter.",
      "FORBIDDEN": "Vous n’avez pas la permission d’effectuer cette action.",
      "NOT_FOUND": "La ressource demandée est introuvable.",
      "CONFLICT": "Cette ressource a été modifiée ailleurs. Veuillez actualiser et réessayer.",
      "RATE_LIMITED": "Trop de requêtes. Veuillez patienter un instant et réessayer.",
      "SERVER_ERROR": "Erreur serveur. Veuillez réessayer.",
      "INVALID_RESPONSE": "Réponse inattendue du serveur. Veuillez réessayer.",
      "CLIENT_FAULT": "Une erreur est survenue dans l'application. Veuillez réessayer.",
      "UNKNOWN": "Une erreur est survenue. Veuillez réessayer."
    },
    "validation": {
      "generic": "Certaines informations sont invalides. Veuillez vérifier votre saisie.",
      "summary": "Veuillez corriger les erreurs ci-dessous."
    }
  },
  "palette": {
    "open": "Rechercher…",
    "placeholder": "Rechercher n'importe quoi…",
    "resultsLabel": "Résultats de recherche",
    "navigateTo": "Aller à {{ label }}",
    "keepTyping": "Continuez à taper…",
    "loading": "Recherche…",
    "noResults": "Aucun résultat",
    "error": "Une erreur est survenue",
    "retry": "Réessayer",
    "resultCount": "{count, plural, =0 {Aucun résultat} =1 {1 résultat} other {# résultats}}",
    "hints": {
      "navigate": "naviguer",
      "run": "exécuter",
      "close": "fermer",
      "esc": "échap",
      "back": "retour",
      "actions": "actions"
    },
    "keys": {
      "enter": "Entrée"
    },
    "groups": {
      "actions": "Actions",
      "commands": "Navigation",
      "reports": "Rapports",
      "orders": "Commandes clients",
      "customers": "Clients",
      "events": "Évènements",
      "subscriptions": "Formules"
    },
    "scope": {
      "all": "Tout",
      "commands": "Navigation",
      "orders": "Commandes",
      "customers": "Clients",
      "events": "Évènements",
      "subscriptions": "Formules"
    },
    "scopeLabel": "Périmètre de recherche",
    "scopePlaceholder": "Rechercher dans {{ scope }}…",
    "clearScope": "Effacer le périmètre",
    "searchAll": "Rechercher dans tout",
    "clearRecents": "Effacer",
    "menu": {
      "recent": "Récent"
    },
    "action": {
      "openOrder": "Ouvrir la commande",
      "openCustomer": "Ouvrir le client",
      "viewEventDetails": "Voir les détails",
      "openPlan": "Ouvrir le plan",
      "openSubscription": "Voir les détails",
      "duplicateSubscription": "Dupliquer",
      "openPriceList": "Aller à la grille tarifaire",
      "resend": "Renvoyer la confirmation",
      "pay": "Marquer comme payée",
      "refund": "Rembourser la commande",
      "cancelOrder": "Annuler la commande",
      "archiveOrder": "Archiver la commande",
      "email": "Envoyer un e-mail",
      "merge": "Fusionner le client…",
      "anonymize": "Anonymiser (RGPD)",
      "archiveCustomer": "Archiver le client",
      "duplicate": "Dupliquer l’évènement",
      "publish": "Publier l’évènement",
      "unpublish": "Dépublier l’évènement",
      "export": "Exporter les participants",
      "cancelEvent": "Annuler l’évènement",
      "failed": "Échec de l’action",
      "reason": {
        "orderArchived": "La commande est archivée",
        "orderCancelled": "La commande est annulée",
        "cantPay": "Paiement impossible — commande {{ status }}",
        "onlyPaidRefunded": "Seules les commandes payées peuvent être remboursées",
        "orderAlreadyCancelled": "La commande est déjà annulée",
        "orderAlreadyArchived": "La commande est déjà archivée",
        "customerAnonymized": "Le client est anonymisé",
        "customerArchived": "Le client est archivé",
        "customerAlreadyAnonymized": "Le client est déjà anonymisé",
        "customerAlreadyArchived": "Le client est déjà archivé",
        "eventCancelled": "L’évènement est annulé",
        "eventAlreadyCancelled": "L’évènement est déjà annulé"
      }
    },
    "drill": {
      "actions": "Actions",
      "dangerZone": "Zone sensible",
      "back": "Retour",
      "placeholder": "Exécuter une action…",
      "confirm": "Confirmer",
      "keep": "Garder",
      "confirmHint": "action irréversible",
      "filterPlaceholder": "Filtrer les actions…",
      "noActions": "Aucune action ne correspond à votre filtre."
    },
    "verb": {
      "jumpTo": "Aller à",
      "open": "Ouvrir",
      "run": "Exécuter"
    },
    "status": {
      "paid": "Payée",
      "pending": "En attente",
      "cancelled": "Annulée",
      "refunded": "Remboursée",
      "upcoming": "À venir",
      "inProgress": "En cours",
      "completed": "Terminé",
      "archived": "Archivé",
      "unknown": "Inconnu"
    }
  },
  "pricingReferential": {
    "searchPlaceholder": "Rechercher tarifs et catégories…",
    "searchLabel": "Rechercher tarifs et catégories",
    "showOnlyInGrid": "Afficher uniquement ce qui est dans la grille",
    "loadFailed": "Impossible de charger les tarifs et catégories.",
    "emptyTitle": "Aucun tarif ni catégorie",
    "emptyMessage": "Créez un tarif ou une catégorie pour commencer à construire votre grille tarifaire.",
    "ratesHeading": "Tarifs",
    "categoriesHeading": "Catégories",
    "createGroup": "Nouveau groupe",
    "createRate": "Nouveau tarif",
    "createRateInGroup": "Nouveau tarif dans ce groupe",
    "createCategory": "Nouvelle catégorie",
    "noResults": "Aucun résultat.",
    "inGrid": "Dans la grille",
    "addToGrid": "Ajouter",
    "addToGridTooltip": "Ajouter à la grille tarifaire",
    "actionsMenuLabel": "Plus d'actions",
    "actions": {
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "move": "Déplacer vers un groupe"
    },
    "form": {
      "name": "Nom",
      "shortName": "Nom court",
      "group": "Groupe",
      "selectGroup": "Sélectionner un groupe",
      "parentGroup": "Groupe parent",
      "noParent": "(aucun)",
      "accountingCode": "Code comptable",
      "priority": "Priorité",
      "color": "Couleur",
      "rateType": "Type de tarif",
      "rateTypeSubscription": "Abonnement",
      "rateTypeExcludingSubscription": "Hors abonnement",
      "nameTaken": "Ce nom est déjà utilisé.",
      "nameTooLong": "Le nom ne doit pas dépasser {{ max }} caractères.",
      "shortNameTooLong": "Le nom court ne doit pas dépasser {{ max }} caractères.",
      "addToGrid": "Ajouter à la grille",
      "duplicateSuffix": "(copie)",
      "cancel": "Annuler",
      "create": "Créer",
      "save": "Enregistrer"
    },
    "rateForm": {
      "createTitle": "Nouveau tarif",
      "editTitle": "Modifier le tarif",
      "duplicateTitle": "Dupliquer le tarif"
    },
    "categoryForm": {
      "createTitle": "Nouvelle catégorie",
      "editTitle": "Modifier la catégorie",
      "duplicateTitle": "Dupliquer la catégorie"
    },
    "rateGroupForm": {
      "title": "Nouveau groupe"
    },
    "moveRate": {
      "title": "Déplacer le tarif",
      "target": "Groupe cible",
      "confirm": "Déplacer"
    },
    "addOutcome": {
      "cascaded": "Ajouté · {count, plural, one {# séance mise à jour} other {# séances mises à jour}}",
      "addedToSessions": "Ajouté aux séances sélectionnées",
      "createdOnly": "Créé",
      "added": "Ajouté à la grille"
    }
  },
  "savedFilters": {
    "errors": {
      "filterNotFound": "Ce filtre enregistré n'existe plus. Il a peut-être été supprimé."
    },
    "selectSavedFilter": "Sélectionner un filtre enregistré",
    "savedFilters": "Filtres enregistrés",
    "modified": "(Modifié)",
    "searchFilters": "Rechercher des filtres...",
    "searchFiltersLabel": "Rechercher des filtres",
    "updateFilter": "Mettre à jour le filtre sélectionné avec les filtres actuels",
    "saveCurrent": "Enregistrer l’actuel",
    "noFiltersMatch": "Aucun filtre ne correspond à « {{ term }} »",
    "noSavedFilters": "Aucun filtre enregistré",
    "availableFilters": "Filtres disponibles",
    "saveFilter": "Enregistrer le filtre",
    "saveFilterSubtitle": "Enregistrez la vue actuelle pour la réutiliser plus tard",
    "filtersToSave": "Filtres à enregistrer",
    "tags": "Tags",
    "removeTagGeneric": "Supprimer le tag",
    "filterName": "Nom du filtre",
    "filterNamePlaceholder": "ex. Concerts à venir",
    "filterNameRequired": "Le nom du filtre est requis",
    "filterNameDuplicate": "Un filtre avec ce nom existe déjà",
    "filterNameMaxLength": "Le nom doit comporter 100 caractères ou moins",
    "tagsOptional": "Tags (optionnel)",
    "addTagPlaceholder": "Ajouter un tag...",
    "addNewTag": "Ajouter un nouveau tag",
    "selectedTags": "Tags sélectionnés",
    "suggestedTags": "Tags suggérés",
    "existingTags": "Tags existants :",
    "removeTag": "Supprimer le tag {{ tag }}",
    "manageSavedFilters": "Gérer les filtres enregistrés",
    "savedViewsCount": "{count, plural, one {# vue enregistrée} other {# vues enregistrées}}",
    "filterCount": "{count, plural, one {# filtre} other {# filtres}}",
    "noMatchesTitle": "Aucun résultat",
    "noSavedFiltersYet": "Aucun filtre enregistré.",
    "saveFilterToSeeHere": "Enregistrez un filtre pour le voir ici.",
    "filterDetails": "Détails du filtre",
    "expandFilterDetails": "Afficher les détails du filtre",
    "collapseFilterDetails": "Masquer les détails du filtre",
    "editFilter": "Modifier le filtre {{ name }}",
    "deleteFilter": "Supprimer le filtre {{ name }}",
    "created": "Créé le",
    "addTag": "Ajouter un tag",
    "deleteFilterConfirm": "Supprimer le filtre ?",
    "deleteFilterMessage": "Êtes-vous sûr de vouloir supprimer « {{ name }} » ?",
    "deleteFilterWarning": "Cette action est irréversible.",
    "loadError": "Échec du chargement des filtres enregistrés.",
    "replaceFiltersConfirm": "Remplacer les filtres actuels ?",
    "replaceFiltersMessagePrefix": "Vous avez des filtres actifs. Appliquer « ",
    "replaceFiltersMessageSuffix": " » remplacera vos réglages de filtres actuels.",
    "replaceFiltersAction": "Remplacer les filtres"
  },
  "sidebar": {
    "toggleLanguage": "Changer de langue",
    "toggleTheme": "Changer le thème",
    "toggleSidebar": "Afficher/masquer la barre latérale",
    "navigation": "Navigation principale",
    "devTools": "Outils de développement"
  },
  "subscriptions": {
    "priceGrid": {
      "title": "Grille tarifaire",
      "save": "Enregistrer",
      "saveSuccess": "Grille tarifaire enregistrée.",
      "saveFailed": "L'enregistrement de la grille tarifaire a échoué.",
      "loading": "Chargement de la grille tarifaire…",
      "naLabel": "N/A",
      "rateColumnHeader": "Tarif",
      "searchButton": "Rechercher",
      "saving": "Enregistrement…",
      "undo": "Annuler",
      "redo": "Rétablir",
      "referential": {
        "manage": "Tarifs et catégories",
        "title": "Tarifs et catégories",
        "actionFailed": "L'action a échoué. Veuillez réessayer.",
        "rateCreated": "Le tarif « {{ name }} » a été créé.",
        "categoryCreated": "La catégorie « {{ name }} » a été créée.",
        "reloadFailed": "La grille n'a pas pu être actualisée. Affichage des données précédentes."
      },
      "history": {
        "label": "Historique",
        "title": "Historique des modifications",
        "close": "Fermer l'historique",
        "empty": "Aucune modification",
        "emptyHint": "Vos modifications apparaîtront ici au fur et à mesure.",
        "undoToHere": "Annuler jusqu'ici",
        "changeCount": "{count, plural, =1 {1 modification} other {# modifications}}",
        "undone": "{count, plural, other {# annulée(s)}}",
        "skipped": "{count, plural, =1 {1 tarif ignoré} other {# tarifs ignorés}}",
        "kind": {
          "editPrice": "Tarif modifié",
          "pasteDetail": "Tarif collé",
          "pasteEvent": "Séance collée",
          "pasteRate": "Tarif collé",
          "pasteDetailRow": "Tarif collé (toutes catégories)",
          "pasteEventRow": "Séance collée (toutes catégories)",
          "pasteRow": "Tarif collé (toutes catégories)",
          "pasteColumn": "Colonne collée",
          "lockEvent": "Séance désactivée",
          "unlockEvent": "Séance activée",
          "lockRate": "Tarif fermé",
          "unlockRate": "Tarif ouvert",
          "lockColumn": "Colonne fermée",
          "unlockColumn": "Colonne ouverte",
          "lockRow": "Tarif fermé (toutes catégories)",
          "unlockRow": "Tarif ouvert (toutes catégories)",
          "createEvent": "Séance ajoutée",
          "deleteEvent": "Séance supprimée",
          "bulkEdit": "Tarifs modifiés en masse"
        }
      },
      "quickSearch": {
        "placeholder": "Rechercher un tarif ou une catégorie…",
        "search": "Rechercher dans la grille tarifaire",
        "esc": "Échap",
        "categories": "Catégories",
        "rates": "Tarifs",
        "noResults": "Aucun résultat pour « {{term}} »",
        "noResultsHint": "Essayez un autre nom de tarif ou de catégorie.",
        "noData": "Rien à rechercher",
        "noDataHint": "Cette grille tarifaire n'a aucun tarif ni catégorie.",
        "navigate": "Naviguer",
        "select": "Sélectionner",
        "resultCount": "{count, plural, =0 {Aucun résultat} one {1 résultat} other {# résultats}}"
      },
      "empty": {
        "title": "Aucun tarif à afficher",
        "body": "Cette formule n'a pas encore de tarifs ni de séances."
      },
      "error": {
        "title": "Impossible de charger la grille tarifaire",
        "body": "La grille tarifaire n'a pas pu être chargée. Réessayez."
      },
      "lock": {
        "rateReadonly": "Ce tarif est en lecture seule.",
        "eventDisabled": "Cette séance est désactivée pour cette catégorie.",
        "cellClosed": "Cette cellule est fermée."
      },
      "contextMenu": {
        "copyDetail": "Copier le prix",
        "pasteDetail": "Coller le prix",
        "copyEvent": "Copier la séance",
        "pasteEvent": "Coller la séance",
        "copyRate": "Copier le tarif",
        "pasteRate": "Coller le tarif",
        "copyDetailRow": "Copier le prix (toutes catégories)",
        "pasteDetailRow": "Coller le prix (toutes catégories)",
        "copyEventRow": "Copier la séance (toutes catégories)",
        "pasteEventRow": "Coller la séance (toutes catégories)",
        "copyRateRow": "Copier le tarif (toutes catégories)",
        "pasteRateRow": "Coller le tarif (toutes catégories)",
        "copyColumn": "Copier la colonne",
        "pasteColumn": "Coller la colonne",
        "enableEvent": "Activer la séance",
        "disableEvent": "Désactiver la séance",
        "addEvent": "Ajouter la séance",
        "deleteEvent": "Supprimer la séance",
        "openAllClosedEvents": "Ouvrir toutes les séances fermées",
        "closeAllOpenEvents": "Fermer toutes les séances ouvertes",
        "openRateAllCategories": "Ouvrir le tarif (toutes catégories)",
        "closeRateAllCategories": "Fermer le tarif (toutes catégories)",
        "openAllRates": "Ouvrir tous les tarifs",
        "closeAllRates": "Fermer tous les tarifs",
        "bulkEdit": "Édition groupée des prix"
      },
      "deleteEvent": {
        "title": "Supprimer la séance",
        "message": "Supprimer cette séance que vous avez ajoutée ? Ses prix seront retirés.",
        "confirm": "Supprimer"
      },
      "paste": {
        "noCompatibleClipboard": "Rien de compatible à coller.",
        "sameSource": "Impossible de coller au même endroit.",
        "notEditable": "Ce tarif est en lecture seule.",
        "skipped": "{{count}} prix n'ont pas pu être collés (tarif en lecture seule ou cible absente)."
      },
      "bulkEdit": {
        "title": "Édition groupée · {{rate}}",
        "events": "Séances",
        "categories": "Catégories",
        "details": "Détails",
        "options": "Options",
        "openClosed": "Ouvrir aussi les séances fermées",
        "openClosedHint": "Activer les séances désactivées du périmètre sélectionné avant d'appliquer les prix.",
        "createMissing": "Créer aussi les cellules manquantes",
        "createMissingHint": "Créer les cellules qui n'existent pas encore pour les catégories et séances sélectionnées.",
        "apply": "Appliquer",
        "cancel": "Annuler",
        "clear": "Effacer",
        "filterEvents": "Filtrer les séances…",
        "filterCategories": "Filtrer les catégories…",
        "noMatches": "Aucun résultat.",
        "amountAriaLabel": "Montant pour {{label}}",
        "summary": "{{events}} séances · {{categories}} catégories · {{details}} détails",
        "applied": "Appliqué : {{amounts}} prix · {{created}} créées · {{opened}} ouvertes.",
        "noCellsAffected": "Aucune cellule affectée.",
        "missing": {
          "events": "Sélectionnez au moins une séance.",
          "categories": "Sélectionnez au moins une catégorie.",
          "details": "Sélectionnez au moins un détail."
        }
      },
      "preview": {
        "willUndo": "Sera annulé",
        "willRedo": "Sera rétabli"
      }
    },
    "duplicate": {
      "copySuffix": " - Copie",
      "title": "Dupliquer la formule",
      "subtitle": "Créez une nouvelle formule à partir de celle-ci en quatre étapes.",
      "loading": "Chargement de la formule à dupliquer…",
      "loadErrorTitle": "Impossible de charger cette formule",
      "loadError": "Cette formule n'a pas pu être chargée. Réessayez ou revenez à la liste.",
      "backToList": "Retour à la liste",
      "invalidSource": "Cette formule ne peut pas être dupliquée."
    },
    "editor": {
      "title": "Nouvelle formule",
      "subtitle": "Créez une formule en quatre étapes.",
      "continue": "Valider et continuer",
      "finish": "Créer la formule",
      "saveDraft": "Enregistrer le brouillon",
      "draftSaved": "Brouillon enregistré.",
      "draftKindLabel": "Formule",
      "stepDone": "Terminé",
      "editStep": "Modifier",
      "steps": {
        "properties": "Propriétés",
        "events": "Événements",
        "pricesCategories": "Tarifs / Catégories",
        "accessRights": "Droits d'accès",
        "comingSoon": "Cette étape arrive bientôt."
      },
      "properties": {
        "nameLabel": "Nom de la formule",
        "nameRequired": "Un nom de formule est requis.",
        "nameTooLong": "Le nom ne peut pas dépasser {{max}} caractères.",
        "nameMarkup": "Le nom ne peut pas contenir de balises ou de scripts.",
        "duplicateWarning": "Une formule portant ce nom existe déjà dans ce groupe.",
        "summaryWithGroup": "{{type}} <strong>{{name}}</strong>, groupe <strong>{{group}}</strong>",
        "summaryNoGroup": "{{type}} <strong>{{name}}</strong>, sans groupe",
        "typeLabel": "Type",
        "typeSubscription": "Formule",
        "typePack": "Pack",
        "groupLabel": "Groupe (optionnel)",
        "groupPlaceholder": "Aucun groupe",
        "groupLoading": "Chargement des groupes…",
        "groupRetry": "Réessayer le chargement"
      },
      "events": {
        "searchPlaceholder": "Rechercher des événements…",
        "sortLabel": "Trier les événements",
        "sortByName": "Nom",
        "sortByDate": "Date",
        "loading": "Chargement des événements…",
        "emptyTitle": "Aucun événement disponible",
        "empty": "Aucun événement à rattacher à cet formule.",
        "loadError": "Impossible de charger les événements.",
        "noMatch": "Aucun événement ne correspond à votre recherche.",
        "unavailable": "Indisponible",
        "toggleSessions": "Afficher ou masquer les séances",
        "allSessions": "Toutes les séances"
      },
      "pricesCategories": {
        "loading": "Chargement des tarifs…",
        "emptyTitle": "Aucun tarif disponible",
        "empty": "Aucun tarif ou catégorie à rattacher à cet formule.",
        "loadError": "Impossible de charger les tarifs.",
        "toggleGroup": "Afficher ou masquer les tarifs",
        "amountLabel": "Montant",
        "amountPlaceholder": "0,00",
        "amountInvalid": "Saisissez un montant jusqu'à 999 999,99 avec au plus 2 décimales.",
        "currencyPrefix": "€",
        "summary": "<strong>{{total}}</strong> tarifs, dont <strong>{{priced}}</strong> tarifés"
      },
      "accessRights": {
        "allProfiles": "Tous les profils",
        "searchPlaceholder": "Rechercher un profil…",
        "noMatches": "Aucun profil ne correspond à votre recherche.",
        "clear": "Effacer",
        "loading": "Chargement des profils…",
        "emptyTitle": "Aucun profil disponible",
        "empty": "Aucun profil d'accès à accorder.",
        "loadError": "Impossible de charger les profils.",
        "summary": "<strong>{{count}}</strong> profils : {{names}}"
      },
      "resumeDraft": {
        "title": "Reprendre le brouillon ?",
        "message": "Vous avez une formule inachevé. Souhaitez-vous le reprendre, recommencer ou revenir à la liste ?",
        "resume": "Reprendre",
        "restart": "Recommencer",
        "backToList": "Retour à la liste"
      },
      "submitSuccess": "Formule créé.",
      "submitIncomplete": "Complétez chaque étape avant de créer la formule.",
      "submitError": {
        "validationFailed": "La formule n'a pas pu être créé. Vérifiez les valeurs saisies et réessayez."
      }
    },
    "detail": {
      "titleLoading": "Formule",
      "openRow": "Ouvrir les détails de {label}",
      "loading": "Chargement des détails de la formule…",
      "loadFailed": "Les détails de la formule n'ont pas pu être chargés.",
      "loadFailedTitle": "Impossible de charger cet formule",
      "tabsAria": "Sections du détail de la formule",
      "tabs": {
        "detail": "Détails",
        "history": "Historique"
      },
      "subtitle": {
        "sessions": "{count, plural, =0 {aucune séance} =1 {1 séance} other {# séances}}",
        "products": "{count, plural, =1 {1 produit} other {# produits}}"
      },
      "lastAction": {
        "created": "Créé le {dateTime}",
        "modified": "Dernière modification le {dateTime}",
        "by": "par {user}"
      },
      "composition": {
        "sessionsTitle": "Séances",
        "productsTitle": "Produits",
        "noDate": "Date à confirmer",
        "noVenue": "Lieu à confirmer",
        "quantity": "{count, plural, =1 {1 billet} other {# billets}}",
        "empty": "Cet formule ne comporte encore aucune séance ni produit.",
        "emptyTitle": "Aucun contenu dans cet formule"
      },
      "activeSalesNotice": "Cet formule ne peut pas être modifié tant que des ventes sont en cours.",
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "prices": "Tarifs",
      "confirmEdit": {
        "title": "Modifier une formule en cours ?",
        "message": "Cet formule est en cours. Le modifier peut affecter les ventes en cours. Voulez-vous continuer ?",
        "confirm": "Continuer la modification",
        "cancel": "Annuler"
      },
      "comment": {
        "title": "Commentaire",
        "noComment": "Aucun commentaire",
        "editComment": "Modifier le commentaire",
        "saveComment": "Enregistrer",
        "cancelEdit": "Annuler",
        "ctrlEnterHint": "Ctrl+Entrée",
        "showMore": "Voir plus",
        "showLess": "Voir moins",
        "saveFailed": "Échec de l'enregistrement du commentaire"
      },
      "history": {
        "loading": "Chargement de l'historique…",
        "empty": "Aucun historique à afficher pour cet formule.",
        "emptyTitle": "Aucun historique pour l'instant",
        "loadFailed": "L'historique n'a pas pu être chargé.",
        "loadMore": "Charger les modifications plus anciennes",
        "loadingMore": "Chargement…",
        "anonymous": "Utilisateur inconnu",
        "by": "par {user}",
        "added": "Ajouté",
        "removed": "Retiré",
        "none": "—",
        "kind": {
          "created": "Formule créé",
          "labelChange": "Libellé modifié",
          "groupChange": "Groupe modifié",
          "commentChange": "Commentaire modifié",
          "eventsChange": "Séances modifiées",
          "ratesChange": "Tarifs modifiés",
          "priceGridChange": "{count, plural, =1 {1 prix modifié} other {# prix modifiés}}",
          "unknown": "Modification enregistrée"
        },
        "filter": {
          "allKinds": "Tous les changements",
          "allOperators": "Tous les opérateurs",
          "operatorLabel": "Opérateur",
          "system": "Système",
          "noMatch": "Aucun changement ne correspond à ce filtre.",
          "kind": {
            "created": "Création",
            "labelChange": "Libellé",
            "groupChange": "Groupe",
            "commentChange": "Commentaire",
            "eventsChange": "Séances",
            "ratesChange": "Tarifs",
            "priceGridChange": "Prix",
            "unknown": "Autre"
          }
        }
      }
    },
    "page": {
      "title": "Formules",
      "subtitle": "Parcourez et gérez les formules",
      "createNew": "Créer une formule",
      "welcomeTitle": "Aucune formule pour le moment",
      "welcomeBody": "Aucune formule n’a encore été créé.",
      "emptyTitle": "Aucun résultat",
      "emptyBody": "Aucune formule ne correspond à votre recherche.",
      "errorTitle": "Impossible de charger les formules",
      "searchLabel": "Rechercher des formules par libellé",
      "searchPlaceholder": "Rechercher par libellé…",
      "salesPeriodPending": "Période de vente à venir",
      "salesPeriodSince": "En vente depuis le {{date}}",
      "salesPeriodFrom": "En vente du {{start}} au {{end}}",
      "totalLabel": "Formules",
      "itemLabel": "formules",
      "columns": {
        "start": "Début",
        "type": "Type",
        "selectionType": "Sélection",
        "label": "Formule",
        "group": "Groupe",
        "salesPeriod": "Période de vente",
        "status": "Statut"
      }
    },
    "card": {
      "tbd": "À définir",
      "salesWindow": "Période de vente",
      "window": {
        "notScheduled": "Non planifié",
        "scheduled": "Bientôt",
        "openEnded": "Sans fin",
        "ended": "Terminé",
        "opensIn": "Ouvre dans {{days}}j",
        "daysLeft": "{{days}}j restants"
      }
    },
    "list": {
      "actions": {
        "columnHeader": "Actions",
        "menuLabel": "Actions pour {label}",
        "duplicate": "Dupliquer",
        "prices": "Tarifs"
      }
    },
    "type": {
      "subscription": "Abonnement",
      "pack": "Pack",
      "short": {
        "subscription": "Abo",
        "pack": "Pack"
      }
    },
    "selectionType": {
      "open": "Ouverte",
      "close": "Fermée"
    },
    "status": {
      "upcoming": "À venir",
      "inProgress": "En cours",
      "pending": "En attente",
      "completed": "Terminé",
      "archived": "Archivé",
      "unknown": "Inconnu"
    },
    "filters": {
      "group": "Groupe",
      "type": "Type",
      "selectionType": "Sélection",
      "status": "Statut",
      "noGroup": "Sans groupe",
      "allGroups": "Tous les formules",
      "groupsTitle": "Groupes",
      "searchGroups": "Rechercher des groupes…",
      "clearSearch": "Effacer la recherche",
      "searchChip": "Recherche",
      "groupsError": "Impossible de charger les groupes",
      "retry": "Réessayer",
      "results": "{count, plural, =0 {Aucune formule} =1 {1 formule} other {# formules}}",
      "viewToggle": "Changer de vue",
      "viewList": "Vue liste",
      "viewTable": "Vue tableau",
      "viewGrid": "Vue grille"
    }
  }
}
